import { IExecutionReportMiscFeesGrp } from "@pulse-ui/codegen/generated_ts/drop_copy";
import { IAssetMarginReportMargins, IParties, IPositionMarginReportMargins } from "@pulse-ui/codegen/generated_ts/position_management";

export const getMiscFees = (fees: IExecutionReportMiscFeesGrp[] | null) => {
    const out: Record<string, { misc_fee_amt: string; misc_fee_curr: string; misc_fee_type: string }> = {};
    if (fees?.length) {
        for (const fee of fees) {
            out[fee.misc_fee_type] = {
                misc_fee_amt: fee.misc_fee_amt?.toString() ?? "",
                misc_fee_curr: fee.misc_fee_curr ?? "",
                misc_fee_type: fee.misc_fee_type?.toString() ?? "",
            };
        }
    }
    return out;
}

export const getParties = (parties: IParties[]) => {
    const out: Record<string, { party_role: string; party_id: string }> = {};
    for (const p of parties) {
        out[p.party_role] = { party_role: p.party_role?.toString() ?? "", party_id: p.party_id };
    }
    return out;
}

export const getMargins = (
    margins: (IAssetMarginReportMargins | IPositionMarginReportMargins)[]
) => {
    const out: Record<string, { margin_amt: string; amt_type: string; notional_margin_amt?: string }> = {};
    for (const m of margins) {
        out[m.amt_type] = {
            margin_amt: m.margin_amt?.toString() ?? "",
            amt_type: m.amt_type?.toString() ?? "",
            ...("notional_margin_amt" in m && { notional_margin_amt: (m as IAssetMarginReportMargins).notional_margin_amt?.toString() }),
        };
    }
    return out;
}